<template>
  <path
    d="M15 18.0002C15 17.4402 14.55 17.0002 14 17.0002H8.41L19.3 6.11022C19.69 5.72022 19.69 5.09021 19.3 4.70021C18.91 4.31021 18.28 4.31021 17.89 4.70021L7 15.5902V10.0002C7 9.45021 6.55 9.00022 6 9.00022C5.45 9.00022 5 9.45021 5 10.0002V18.0002C5 18.5502 5.45 19.0002 6 19.0002H14C14.55 19.0002 15 18.5502 15 18.0002Z"
  />
</template>
